import { createFileRoute } from "@tanstack/react-router";

import { AdminEduRunsPage } from "@/components/AdminEduRunsPage";

// /admin/edu-runs — прохождения подбора вузов (04.11.2026). noindex.
export const Route = createFileRoute("/admin_/edu-runs")({
  head: () => ({
    meta: [{ title: "Подбор вузов — Yolutap" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: AdminEduRunsPage,
});
